import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {DocumentTypeModel} from '../../../shared/dto/document-type.model';
import {DomSanitizer} from '@angular/platform-browser';
import {DocumentDetailsService} from '../../../service/document-details.service';
import Swal from "sweetalert2";
import {DocumentPage} from '../../../shared/dto/document-page';

@Component({
  selector: 'app-document-viewer-popup',
  templateUrl: './document-viewer-popup.component.html',
  styleUrls: ['./document-viewer-popup.component.scss']
})
export class DocumentViewerPopupComponent implements OnInit {

  @Input() fromParent;
  public loader: boolean = false;
  public pages:DocumentPage;
  documentDetails: any = [];
  docType: DocumentTypeModel = new DocumentTypeModel();

  constructor(
    private documentDetailsService: DocumentDetailsService, private sanitizer: DomSanitizer,) {
  }

  ngOnInit() {
    this.docType = this.fromParent.doc;
    this.getPages();
  }

  ngOnDestroy(): void {
    this.docType = null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['docType']) {
      this.docType = this.fromParent.doc;
      this.getPages();
    }
  }


  transform(base64Image) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(base64Image);
  }

  getPages() {
    this.loader = true;
    this.documentDetailsService.getPages(this.docType).subscribe(
      (data) => {
        if (data !== null && data !== "") {
          this.pages = data;
          this.pages.content.forEach(element => {
            this.documentDetails.push(element);
          });
        }
        this.loader = false;
      },
      error => {
        this.loader = false;
        Swal.fire(`Internal Server Error`, error.message, "error");
      }
    );
  }

}
